// Generated by Melange

import * as Buhta_cabinet__Btn from "../../../html/Btn.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GlobalStateContext from "../../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Cn from "../../../../../../../vendored/classnames/Cn.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as JsxRuntime from "react/jsx-runtime";

function TaxPaymentsSettingsEmployees(Props) {
  let goToNext = Props.goToNext;
  const employees = {
    hd: "",
    tl: /* [] */ 0
  };
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs("div", {
          children: [
            Stdlib__List.length(employees) > 0 ? JsxRuntime.jsx("div", {
                children: JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                          className: "!font-mediumbold",
                          children: "Абильденов Абилкасым Ерланович"
                        }),
                        JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                          className: "text-gray-medium",
                          children: "Ведущий бухгалтер"
                        }),
                        deviceType === "mobile" ? JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                            className: "font-mediumbold mt-4",
                            children: "100 000 ₸"
                          }) : null
                      ],
                      className: "flex flex-col gap-1"
                    }),
                    JsxRuntime.jsxs("div", {
                      children: [
                        deviceType === "tablet" ? JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                            className: "font-mediumbold",
                            children: "100 000 ₸"
                          }) : null,
                        JsxRuntime.jsx("img", {
                          className: "w-5 h-5",
                          alt: "more",
                          src: StaticAsset.src("/static/icons/more.svg")
                        })
                      ],
                      className: "flex items-center gap-4"
                    })
                  ],
                  className: "flex items-center justify-between"
                }),
                className: "flex flex-col p-4 border border-gray-main rounded"
              }) : JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("img", {
                    className: "w-10 h-10",
                    alt: "people",
                    src: StaticAsset.src("/static/icons/people-gray-40.svg")
                  }),
                  JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                    className: "mt-4",
                    children: "Добавьте сотрудников в предприятие"
                  }),
                  JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                    className: "mt-2 text-asphalt",
                    children: "Вам не нужно будет вручную заполнять сотрудников каждый раз, налоги посчитаются автоматически"
                  })
                ],
                className: "md:px-10"
              }),
            JsxRuntime.jsxs("button", {
              children: [
                JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                  className: Stdlib__List.length(employees) > 0 ? "text-black" : "text-links",
                  children: "Добавить сотрудника"
                }),
                JsxRuntime.jsx("img", {
                  className: "w-4 h-4",
                  alt: "plus",
                  src: StaticAsset.src(Stdlib__List.length(employees) > 0 ? "/static/icons/plus-black.svg" : "/static/icons/plus-blue-16.svg")
                })
              ],
              className: Cn.fromList({
                hd: "mt-4 w-full md:w-max justify-center border border-gray-main rounded-sm px-3 py-2 flex gap-1 items-center",
                tl: {
                  hd: Stdlib__List.length(employees) > 0 ? "" : "md:mx-10",
                  tl: /* [] */ 0
                }
              }),
              type: "button",
              onClick: goToNext
            })
          ],
          className: "py-10 px-6 md:p-10"
        }),
        className: "bg-white md:w-[562px] rounded-md"
      }),
      JsxRuntime.jsx("div", {
        children: Stdlib__List.length(employees) > 0 ? JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
            title: "Сохранить",
            className: "w-full md:w-max px-6 py-3",
            type_: "submit"
          }) : JsxRuntime.jsx("button", {
            children: JsxRuntime.jsx(Buhta_components__Text.H4.make, {
              children: "Пропустить"
            }),
            className: "border w-full md:w-max border-gray-main rounded-sm px-6 py-3",
            type: "button"
          }),
        className: "md:w-[562px] flex md:justify-end mt-6"
      })
    ]
  });
}

const make = TaxPaymentsSettingsEmployees;

export {
  make,
}
/* Buhta_cabinet__Btn Not a pure module */
